import { formatObject } from "../../../features/dataFormatFunctions/formatObject";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { store } from "../../../stateManagement/store";
import { getObjectTypeFromLayerName } from "../../map/mapFeatures/mapFunctions/getObjectsOnMapPoint/handleFeature/default"

export const PROPERTIES_FOR_OBJECT_ON_MAP_NODE_LABEL: any = {
    RoadLandLots: {
        caption: "Кадастровый номер",
        field: "CadastralNumber"
    },
    AdjacentLandLots: {
        caption: "Кадастровый номер",
        field: "CadastralNumber"
    },
    LandSubLots: {
        caption: "Кадастровый номер",
        field: "CommonCadastralNumber"
    },
    LandSubLotObjects: {
        caption: "Кадастровый номер",
        field: "CommonCadastralNumber"
    }
}

export function configureObjectsInfoTree(objectFeatures: any[]) {
    const objectFeaturesGroupedByRoadAndPath: any = Object.groupBy(objectFeatures, ({ properties: { RoadName, PathName } }: any) => {
        if (RoadName) return `${RoadName}/${PathName}`;
        return "Без привязки к дороге";
    })
    for (const [key, value] of Object.entries(objectFeaturesGroupedByRoadAndPath)) {
        objectFeaturesGroupedByRoadAndPath[key] = Object.groupBy(value, (feature => {
            const [layerName, id] = feature?.id.split('.')
            return getObjectTypeFromLayerName(layerName)
        }))
    }
    return objectFeaturesGroupedByRoadAndPath
}

export function configureObjectTypesTreeNodes(roadAndPath: string, objectTypesTree: any) {
    const treeNodes: any[] = []
    const objectTypes = getItemWebStorage("objectTypes")
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    const token = store.getState().auth.tokens.app
    Object.entries(objectTypesTree).forEach(([objectTypeName, objects]: any, parentIndex) => {
        const objectTypeInfo = objectTypes.find((objectType: any) => objectType.name === objectTypeName)
        const { caption, imageIndex, captionSingular } = objectTypeInfo ?? {}
        const parentNode: any = {
            key: `${parentIndex}`,
            label: caption,
            isParentNode: true,
            imageIndex,
            children: []
        }
        objects.forEach((object: any, childIndex: number) => {
            const formattedProperties = formatObject(object.properties)
            const { PathPosition, PathEnding, PlacementString, InfoObjectID: id } = formattedProperties ?? {}
            const parts = [];
            if (PathPosition) parts.push(`${PathPosition} км`);
            if (PathEnding) parts.push(`— ${PathEnding} км`);
            if (PlacementString) parts.push(`— ${PlacementString}`);
            const positionString = parts.length ? ` (${parts.join(' ')})` : '';
            let labelDescription = positionString
            const { caption: labelFieldCaption, field: labelField } = PROPERTIES_FOR_OBJECT_ON_MAP_NODE_LABEL?.[objectTypeName] ?? {}
            const labelFieldValue = formattedProperties[labelField]
            if (labelField && labelFieldValue != null) {
                labelDescription = labelFieldCaption ? `(${labelFieldCaption} - ${labelFieldValue})` : `(${labelFieldValue})`;
            }
            const label = `${captionSingular} ${labelDescription}`;
            const link = `/app/table/${objectTypeName}/${id}`;
            let childNode: any = {
                key: `${parentIndex}-${childIndex}`,
                label,
                imageIndex,
                link,
                objectType: objectTypeName,
                roadAndPath
            }
            if (objectTypeName === "RoadSigns") childNode = { ...childNode, imageSrc: `${currentApiUrl}/objects/roadSignImage?Token='${token}'&Id=${id}&Width=300&Height=300` }
            parentNode.children.push(childNode)
        })
        treeNodes.push(parentNode)
    })
    return treeNodes
}